<template>
  <div>
    <div class="ahead-tabs">
      <div class="ahead-tabs-item active" @click="$router.push(`/v3/search_page/?tab=article`)">科普文章</div>
      <div class="ahead-tabs-item" @click="$router.push(`/v3/search_page/?tab=drug`)">药品信息</div>
    </div>
    <div class="searchText maxWidth hideInPC">
      <select v-model="selectedSearchType" >
        <option  value="content">全文</option>
        <option value="title">标题</option>
        <option  value="author">作者</option>
      </select>
      <input type="text" placeholder="按科室搜索疾病、症状" v-model="searchKey" @keyup.enter="searchText" v-focus="isFocusSearch">
      <span class="searchBtn" @click="searchText">🔍 </span>
    </div>
    <div class="catoryBox">
    <img src="../assets/search.png" class="hideInMobile" alt=""  @click="enterGlobalSearch">
    <div class="tag hideInPC" @click="enterGlobalSearch">所有科室</div>
      <div class="tag" :class="{'active': (selectedCatory == category.id)}" v-for="category in categoryList" :key="category.id" @click="tapTheTag(category)" v-if="category.showFlag">{{category.name}}</div>
      <div class="subCategoryBox" v-if="showSubCategory">
        <div class="wrap subTitleWrap">
          <div class="flex-between">
            <div style="text-align:center;padding:0.5rem;color:#006d82;font-size:1rem;white-space:nowrap;">
            {{categoryName}}
          </div>
            <div class="flex-between">
              <div class="searchText maxWidth hideInMobile">
                <select v-model="selectedSearchType" >
                  <option  value="content">全文</option>
                  <option value="title">标题</option>
                  <option  value="author">作者</option>
                </select>
                <input type="text" placeholder="按科室搜索疾病、症状" v-model="searchKey" @keyup.enter="searchText" v-focus="isFocusSearch">
                <span class="searchBtn" @click="searchText">🔍 </span>
              </div>
              <div class="btnSwitchFunction" @click="btnGetAllArticle">查看所有文章</div>
            </div>
          </div>
          <!--<img src="../assets/CLOSE2.png" class="closeSubCategoryBoxBtn" alt="" @click="closeSubTitleWrap()">-->
          <div class="subBox" v-for="subCategory in subCategoryList" :key="subCategory.id">
            <div class="subTitle">{{subCategory.name}}</div>
            <div class="subContentBox">
              <div class="subContent" :class="{'activeSubCatalog': (selectedSubCatory == catalog.id)}" v-for="catalog in subCategory.catalogs" :key="catalog.id" @click="selectedSubContent(catalog, subCategory)">
              {{catalog.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="flex-between subCategoryTreeBlockShow" style="height:2.5rem;margin-top: 8px;">
          <div style="text-align:left;padding:0.5rem;color:#006d82;font-size:1rem;" class="subCategoryTreeShow">
            <span style="cursor:pointer;" @click="btnGetAllSubTitle">{{categoryName}} </span>  {{subCategoryName ? '->' + subCategoryName : ''}}
          </div>
          <div class="flex-between">
            <div class="searchText subCategoryShow" :class="{'maxWidth':(!categoryName)}">
              <select v-model="selectedSearchType" >
                <option  value="content">全文</option>
                <option value="title">标题</option>
                <option  value="author">作者</option>
              </select>
              <input type="text" placeholder="请输入关键词" v-model="searchKey" @keyup.enter="searchText" v-focus="isFocusSearch">
            <img src="../assets/search.png" alt="" @click="searchText" >
              <!--<span class="searchBtn" @click="searchText">🔍 全局检索</span>-->
              <!--<span class="searchBtn" v-if="categoryName" @click="searchTextByCatelog">🔍 当前目录检索</span>-->
            </div>
            <div class="btnSwitchFunction" @click="btnGetAllSubTitle">返回科室目录</div>
          </div>
      </div>
      <div class="articleList">
        <div v-if="articleList.length === 0" style="text-align:center;padding-top:20px;color:#999;">-- 在当前目录下暂无匹配相关文章，切换其他目录看看 --</div>
        <div class="article" v-for="article in articleList" :key="article.id" @click="turnToArticle(article)">
        <img class="hideInMobile" :src="article.thumb" alt="">
          <div class="infoBox">
            <div class="title"><div class="author" v-if="article.author">{{article.author}} : </div>{{article.title}}</div>
            <div class="desc hideInMobile">{{article.digest}}</div>
          </div>
        </div>
      </div>
      <div class="loadmore" @click="loadmoreArticle" v-if="hasNext">加载更多...</div>
    </div>
  </div>
</template>
<style  lang="less" scoped>
@import '../style/page.less';
.searchText{
  min-width: 360px;
  width: 50%;
  height: 36px;
  // margin: 0 0 20px 30px;
  // display: flex;
  align-items: center;
  color: #999;
  padding: 0 14px 0 14px;
  border-radius: 20px;
  // border: 1px solid #eee;
  select{
    color: #666;
  }
  img{
    padding:4px 10px 0 0;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  input{
  // background:none;
	outline:none;
	border:0px;
  width:100%;
  margin: 0 10px;
  // border-bottom:1px solid #999;
  }
  input::placeholder {
    color: #ddd;
  }
  .searchBtn{
    cursor: pointer;
    color: #006d82;
    margin: 6px 8px;
    border-radius: 8px;
    font-size: 1.1rem;
    white-space: nowrap;
    // background: #006d82;
    opacity: 0.8;
    // margin-left: 10px;
    // color: #666;
    // border:1px solid #666;
    // background: #fefefe;
  }
}
.catoryBox {
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 10px 0;
  border-bottom: 1px solid #ddd;
  img{
    // border-left: 1px solid #ddd;
    padding:0 10px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    margin: 12px;
  }
}
.maxWidth{
  width: 100%;
}
</style>
<script>
import axios from "axios";
import common from "../common";
export default {
  name: "",
  data() {
    return {
      host: common.network.v2host,
      categoryList: [],
      categoryId: "",
      subCategoryList: [],
      articleList: [],
      hasNext: true,
      selectedCatory: '',
      selectedSubCatory: '',
      showSubCategory: false,
      getArticleParams: {
        searchKey: '',
        type: 'content',
        start: 0,
        limit: 20,
        catalogId: ''
      },
      selectedSearchType: 'content',
      searchKey: '',
      subCategoryName: '',
      isFocusSearch: false
    }
  },
  mounted: function() {
    let selectedCategory = ''
    // if (this.$route.query.category) {
      if (!this.$route.query.category) {
        this.isFocusSearch = true
      }
      let decodeStr = decodeURI(this.$route.query.category);
      axios({
        method: "get",
        url: this.host + "available_services",
        data: {}
      })
        .then(res => {
          if (res.status === 200) {
            this.categoryList = res.data;
            if (this.$route.query.category) {
              this.categoryList.some((ele, index, arr) => {
                if (ele.name.indexOf(decodeStr) != -1) {
                  this.categoryId = ele.id;
                  selectedCategory = ele
                  return true;
                } else {
                  return false;
                }
              })
            } else {
              this.hasNext = false
            }
            if(this.categoryId === ""){
              throw '没有匹配到此分类'
            } else {
              this.matchSubTitle(selectedCategory)
              this.showSubCategory = true
              this.selectedCatory = this.categoryId
              this.getArticleParams.catalogId = this.selectedCatory
              // return this.getArticle(this.getArticleParams, true)
            }
          }
        })
    // }
  },
  methods: {
    btnGetAllArticle: function() {
      // console.log(this.getArticleParams)
      this.getArticleParams.catalogId = this.categoryId
      this.subCategoryName = ''
      this.getArticle(this.getArticleParams, true)
      this.showSubCategory = false
    },
    btnGetAllSubTitle:function() {
      // location.reload()
      this.matchSubTitle({id: this.selectedCatory, name: this.categoryName})
      this.showSubCategory = true
      this.selectedSubCatory = ''
      this.subCategoryName = ''
      this.getArticleParams.searchKey = ''
      this.searchKey = ''
      this.articleList = []
    },
    getArticle: function(parms, clear) {
      let self = this;
      if (clear) {
        this.getArticleParams.searchKey = ''
        this.searchKey = ''
        this.getArticleParams.type = 'content',
        this.getArticleParams.start = 0
        self.articleList = []
      }
      axios({
        method: "get",
        url: self.host + "articles",
        params: parms
      }).then(res => {
        if (res.status === 200 ) {
          if (self.getArticleParams.start == 0) {
            self.articleList = res.data.articles.data;
          } else {
            self.articleList = self.articleList.concat(res.data.articles.data);
          }
          self.articleList.forEach(item=>{
            item.thumb = self.processWechatImg(item.thumb)
          })
          self.hasNext = res.data.articles.hasNext;
          if (self.hasNext) {
            self.getArticleParams.start += self.getArticleParams.limit;
          }
        }
      });
    },
    matchSubTitle: function(item) {
      if (this.selectedCatory == item.id && this.subCategoryList.length != 0) {
        this.selectedSubCatory = ''
        // this.showSubCategory = !this.showSubCategory
        // this.btnGetAllArticle()
        return
      }
      this.articleList = []
      this.selectedSubCatory = ''
      this.subCategoryName = ''
      this.searchKey = ''
      this.categoryId = item.id
      this.getArticleParams.start = 0;
      this.selectedCatory = item.id
      this.getSubTitle(item)
      this.getArticleParams = {
        ...this.getArticleParams,
        searchKey: '',
        catalogId: item.id
      }
    },
    tapTheTag: function(item) {
      this.$router.replace(`/v3/article_page/?category=${item.name}`)
      this.matchSubTitle(item)

      // this.getArticle(this.getArticleParams, true);
    },
    getSubTitle: function(item) {
      let self = this;
      axios({
        method: "get",
        url: this.host + item.id + "/catalogs"
      }).then(res => {
        if (res.status === 200 ) {
          this.subCategoryList = res.data
          this.showSubCategory = true
        }
      });
    },
    turnToArticle: function(article) {
      let self = this;
      let parms = {
        utmSource: 'pc',
        utmMedium: this.searchKey ? 'full-text' : 'catalog',
        utmContent: `${this.categoryName}${this.subCategoryName ? ',' + this.subCategoryName.replace(' -> ',',').trim() : ''}`,
        utmTerm: this.searchKey ? this.searchKey : '',
        utmCampaign: article.title,
        articleId: article.id
      }
      axios({
        method: "get",
        url: self.host + "link/" + article.id,
        params: parms,
        headers: {
          platform: 'pc'
        }
      }).then(res => {});
      window.open(article.link);
    },
    loadmoreArticle: function() {
      // this.getArticleParams.start += this.getArticleParams.limit;
      this.getArticle(this.getArticleParams);
    },
    processWechatImg: function(urlText) {
        var url = urlText+'X',
            time = new Date().getTime(),
            frameid = 'wechatImg_' + time;
        window.WechatImgTemp = '<img id="img" style="width:100%" src=' + url + '?' + time + ' />';
        var iframe = '<iframe id="' + frameid + '"  src="javascript:parent.WechatImgTemp;" frameBorder="0" scrolling="no" width="100%"></iframe>';
        return url + '?0.' + time
        // jQele.after(iframe).remove()
    },
    selectedSubContent: function(item, subCategoryItem) {
      // console.log(item)
      this.showSubCategory = false
      this.selectedSubCatory = item.id
      this.getArticleParams.catalogId = item.id
      this.subCategoryName = `${subCategoryItem.name} -> ${item.name}`
      this.getArticle(this.getArticleParams, true)
    },
    closeSubTitleWrap: function() {
      this.showSubCategory = false
    },
    searchText: function() {
      this.getArticleParams = {
        ...this.getArticleParams,
        type: this.selectedSearchType,
        catalogId: this.subCategoryName ? this.selectedSubCatory : this.selectedCatory,
        searchKey: this.searchKey,
        start: 0
      }
      // this.selectedCatory = ''
      // this.selectedSubCatory = ''
      // this.subCategoryName = ''
      this.articleList = []
      this.getArticle(this.getArticleParams)
      this.showSubCategory = false
    },
    searchTextByCatelog: function() {
      this.getArticleParams = {
        ...this.getArticleParams,
        type: this.selectedSearchType,
        catalogId: this.selectedSubCatory ? this.selectedSubCatory : this.selectedCatory,
        searchKey: this.searchKey,
        start: 0
      }
      this.articleList = []
      this.getArticle(this.getArticleParams)
    },
    enterGlobalSearch: function() {
      this.$router.push('/v3/search_page/')
    }
  },
  computed: {
    categoryName: function() {
      let selectedCategoryName = ''
       this.categoryList.some((ele, index, arr) => {
          if (ele.id === this.selectedCatory) {
            selectedCategoryName = ele.name;
            return true;
          } else {
            return false;
          }
        })
      return selectedCategoryName
    }
  },
  directives: {
  focus: {
      // 指令的定义
      inserted: function (el) {
        el.focus()
      }
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/pages/articlePageV3.vue